export default __webpack_public_path__ + "static/media/meliImg_2.b5a953aa.png";